import createStyles from '@mui/styles/createStyles'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { useTranslation } from 'next-i18next'

// TODO -- Change css to react themes.pallet.primary.main (or whichever is the color)
// const blueColor = "rgb(0, 150, 255)";
// const blueColor = '#c1a578' // Primry color // original
// const blueColor = "#2b2b2b"; // Pilka
// const blueColor = "#f6f6f4";

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      wrapper: {
        color: '#ffffff',
        // color: "#2b2b2b",
        backgroundColor: theme.palette.secondary.main,
        paddingLeft: '15px',
        paddingRight: '15px',
        display: 'block',
        marginTop: '10px',
        position: 'relative',
        lineHeight: '2',
        textAlign: 'center',

        [theme.breakpoints.down('sm')]: {
          padding: 1,
          marginTop: '3px',
          fontSize: '11px',
          lineHeight: '1.6',
        },

        '&::after': {
          content: '""',
          position: 'absolute',
          right: '-8px',
          bottom: '0',
          width: '0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: '0 8px 12px 0',
          borderColor: `transparent transparent ${theme.palette.secondary.main} transparent`,
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          right: '-8px',
          top: ' 0',
          width: ' 0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: '12px 8px 0 0',
          borderColor: `${theme.palette.secondary.main} transparent transparent transparent`,
        },
      },

      wrapperLeft: {
        color: '#ffffff',
        lineHeight: '2',
        backgroundColor: theme.palette.secondary.main,
        paddingLeft: '15px',
        paddingRight: '15px',
        display: 'block',
        marginTop: '10px',
        position: 'relative',
        textAlign: 'center',

        [theme.breakpoints.down('sm')]: {
          padding: 1,
          marginTop: '3px',
          fontSize: '11px',
          lineHeight: '1.6',
        },

        '&::before': {
          content: '""',
          position: 'absolute',
          left: '-8px',
          top: '0',
          width: '0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: '0 8px 12px 0',
          borderColor: `transparent ${theme.palette.secondary.main} transparent transparent`,
        },

        '&::after': {
          content: '""',
          position: 'absolute',
          left: '-8px',
          bottom: ' 0',
          width: ' 0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: '0 0 12px 8px',
          borderColor: `transparent transparent ${theme.palette.secondary.main} transparent`,
        },
      },

      smallModify: {
        padding: 1,
        marginTop: '5px',
        fontSize: '12px',
        lineHeight: '1.6',
      },
    }),
  { name: 'MuiNewProductBadge' },
)

const NewProductBadge = ({ left = false, small = false }) => {
  const classes = useStyles() as any

  const { t } = useTranslation(['common'])
  const newString = t('new-badge-text')

  return (
    <div
      className={`${left ? classes.wrapperLeft : classes.wrapper}  ${
        small ? classes.smallModify : ''
      }  `}
    >
      <span>NEW</span>
    </div>
  )
}

export default NewProductBadge
